<template>
  <div>
    <v-row align="center" justify="center">
      <v-col>
        <v-autocomplete
          v-model="filter.building_complex"
          :label="$t('BUILDING_COMPLEXES.ITEM')"
          :search-input.sync="building_complex"
          :items="building_complexes"
          :loading="loading"
          item-text="name"
          item-value="id"
          :no-data-text="$t('TASKS.NO_DATA_FILTER_TEXT')"
          clearable
          v-on="{
            change: [getDataBuildings, getDataResources]
          }"
        ></v-autocomplete>
      </v-col>
      <v-col>
        <v-autocomplete
          v-model="filter.building"
          :label="$t('BUILDINGS.ITEM')"
          :items="buildings"
          :loading="loading"
          :search-input.sync="building"
          item-text="street"
          item-value="id"
          :no-data-text="$t('TASKS.NO_DATA_FILTER_TEXT')"
          clearable
          v-on="{
            change: [getDataResources]
          }"
        ></v-autocomplete>
      </v-col>
      <v-col>
        <v-autocomplete
          v-model="filter.resource"
          :label="$t('BOOKING.RESOURCES.ITEM')"
          :items="resources"
          :loading="loading"
          :search-input.sync="resource"
          item-text="title"
          item-value="id"
          :no-data-text="$t('TASKS.NO_DATA_FILTER_TEXT')"
          clearable
        ></v-autocomplete>
      </v-col>

      <v-col>
        <v-btn
          color="primary"
          depressed
          :disabled="!filter.resource"
          @click.prevent="setData"
        >
          {{ $t('BUTTON.FIND') }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { periodFormat } from '@/modules/_global/filters';
import { cloneDeep, isEmpty } from 'lodash';

export default {
  name: 'TasksListFilter',

  filters: {
    periodFormat
  },

  data: () => ({
    options: {},

    resource: null,
    building_complex: null,
    building: null,
    resources: [],
    building_complexes: [],
    buildings: [],

    filter: {}
  }),

  computed: {
    ...mapState(['loading']),
    ...mapState('booking_schedule', ['bookingScheduleFilter'])
  },

  created() {
    if (!isEmpty(this.bookingScheduleFilter)) {
      this.filter = cloneDeep(this.bookingScheduleFilter);
      this.getDataBuildings();
      if (this.filter.resource) {
        this.setData();
      }
    }
    this.getDataBuildingComplexes();
    this.getDataResources();
  },

  methods: {
    ...mapActions('booking_schedule', [
      'getFilteredBuildingComplexes',
      'getFilteredBuildings',
      'getFilteredResources',
      'setFilter'
    ]),

    setData() {
      this.$emit('setRequest', cloneDeep(this.filter));
      this.setFilter(this.filter);
    },
    getDataBuildingComplexes() {
      this.getFilteredBuildingComplexes({ search: this.building_complex })
        .then(({ data }) => {
          this.building_complexes = data.data;
        })
        .catch(error => {
          this.error = error;
        });
    },
    getDataBuildings() {
      this.getFilteredBuildings({
        building_complex: [this.filter.building_complex]
      })
        .then(({ data }) => {
          this.buildings = data.data;
        })
        .catch(error => {
          this.error = error;
        });
    },
    getDataResources() {
      this.getFilteredResources({
        building_complex: this.filter.building_complex,
        building: this.filter.building
      })
        .then(({ data }) => {
          this.resources = data.data;
          if (
            this.filter.resource &&
            !this.resources.some(el => el.id === this.filter.resource)
          ) {
            this.filter.resource = null;
          }
        })
        .catch(error => {
          this.error = error;
        });
    },
    reset() {
      this.resource = null;
      this.building = null;
      this.buildings = [];
      this.building_complex = null;
      this.filter = {};

      this.setData();
    }
  }
};
</script>
